import React from 'react'

interface FileUploadDTProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const FileUploadDT: React.FC<FileUploadDTProps> = ({
  size = 20,
  color = '#003366',
  className,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path d="M7.49967 14.168V9.16797L5.83301 10.8346" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.5 9.16797L9.16667 10.8346" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18.3337 8.33464V12.5013C18.3337 16.668 16.667 18.3346 12.5003 18.3346H7.50033C3.33366 18.3346 1.66699 16.668 1.66699 12.5013V7.5013C1.66699 3.33464 3.33366 1.66797 7.50033 1.66797H11.667" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18.3337 8.33464H15.0003C12.5003 8.33464 11.667 7.5013 11.667 5.0013V1.66797L18.3337 8.33464Z" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export default FileUploadDT
